import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
} from '@angular/core'
import {faChevronLeft} from '@fortawesome/pro-solid-svg-icons/faChevronLeft'
import {SidenavItemComponent} from './sidenav-item/sidenav-item.component'

@Component({
  selector: 'cft-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SidenavComponent implements OnInit, AfterContentInit {
  @Input()
  initiallyOpen = true

  @Output()
  openStateChange = new EventEmitter<{open: boolean}>()

  open = true
  openIcon = faChevronLeft

  @ContentChildren(SidenavItemComponent, {descendants: true}) items!: QueryList<SidenavItemComponent>
  animating = false

  element = this.elementRef.nativeElement

  constructor(private readonly elementRef: ElementRef<HTMLDivElement>) {}

  ngOnInit(): void {
    this.open = this.initiallyOpen
  }

  ngAfterContentInit() {
    if (!this.initiallyOpen) {
      this.items.map(x => x.close())
    }
  }

  toggleOpen() {
    if (this.animating) {
      return
    }
    const open = this.open
    this.open = !this.open

    if (open) {
      this.items.map(x => x.close())
    }

    this.openStateChange.emit({open: this.open})
  }

  animationStart() {
    this.animating = true
  }

  animationEnd() {
    this.animating = false
    if (this.open) {
      this.items.map(x => x.open())
    }
  }
}
